<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-09-23 14:12:06
 * @LastEditors: WangYuhan
-->
<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    :show-close="false"
    width="30%"
    :before-close="handleClose"
  >
    <span>您还没有创建企业，请前往创建</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">暂不创建</el-button>
      <el-button type="primary" @click="dialogVisibleClick">创建企业</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  created() {
    // 判断是否有企业
    if (localStorage.getGroupLen == 0) {
      setTimeout(() => {
        this.dialogVisible = true;
      }, 3000);
    }
  },
  methods: {
    dialogVisibleClick() {
      this.dialogVisible = false;

      window.open('/enterprise/enterpriseInfo/create');
    },
  },
};
</script>
